import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { observer, inject } from 'mobx-react';

import { localeStrings as strings } from 'applicationConfig';
import paths from '../../../common/constants/paths';
import menuAccessTypes from '../../../common/constants/menuAccessTypes';
import tpicapLogo from 'src/common/images/tpicap-logo.png';
import { withAuth } from 'src/common/auth/Auth';

const menu = (userStore) => {
    let sliceFileLinkPath = userStore.parameters.getAll().sliceFileLinkPath;
    let menu = [
        { component: <NavLink to={paths.dataSelect}>{strings.pageTitles.dataSelect}</NavLink>, access: menuAccessTypes.authenticated },
        { component: <NavLink to="/my-account/details">{strings.pageTitles.myAccount}</NavLink>, access: menuAccessTypes.authenticated },
        { component: <a href="/auth/logout">{strings.generic.logout}</a>, access: menuAccessTypes.authenticated },
        { component: <NavLink to="/login">{strings.generic.login}</NavLink>, access: menuAccessTypes.unAuthenticated },
    ];

    if (sliceFileLinkPath) {
        menu.unshift({ component: <a href={sliceFileLinkPath}>{strings.pageTitles.sliceFileFeed}</a>, access: menuAccessTypes.authenticated });
    }
    return menu;
};

const ShellHeader = inject('userStore')(
  observer((props) => {
    const isAuthenticated = props.auth.isAuthenticated();
    const access = isAuthenticated ? menuAccessTypes.authenticated : menuAccessTypes.unAuthenticated;
    return (
      <div className={`shell-header  ${props.className || ''}`}>
        <div className="logo-container">
          <div className="logo-wrap">
            <Link to={paths.home}>
              <img src={tpicapLogo} className="icon" alt="TPICAP Corporation" />
            </Link>
          </div>
          <div>
            <div className="nav-container">
              {menu(props.userStore)
                .filter(item => item.access === menuAccessTypes.both || item.access === access)
                .map((item, index) => (
                  <span className="link-container" key={index}>
                    {item.component}
                  </span>
                ))}
            </div>
            {isAuthenticated && <div>
              <span>
                <b>{strings.generic.loggedInAs} </b>
              </span>
              <span>{props.userStore.email} </span>
            </div>}
          </div>
        </div>
      </div>
    );
  })
);

export default withAuth(withRouter(ShellHeader));



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/ShellHeader.jsx